$(document).ready(function () {
  // set the value of the saerch input to the search param in the url
  var url = new URL(window.location.href);
  var search = url.searchParams.get("search");
  $('input[name="search"]').val(search);

  addMonthDividers();

  updateClearButtonState();

  hideLoadingMessage();

  // Event listener for dropdown changes
  $(".dropdown-filter").change(function () {
    console.log("triggering filter update...");
    // clear the search
    $('input[name="search"]').val("");
    // set placeholder to keyword
    $('input[name="search"]').attr("placeholder", "Keyword");
    // remove the search param from the url
    var url = new URL(window.location.href);
    url.searchParams.delete("search");
    window.history.replaceState({}, "", url);

    updateFilters();
  });

  $(".category-clear").click(function (e) {
    var search = $('input[name="search"]').val();
    if (!search) {
      e.preventDefault();
      $('select[name="eventType"]').val("all");
      $('select[name="region"]').val("all");
      updateFilters();
      updateClearButtonState();
    }
  });

  function updateClearButtonState() {
    console.log("updating clear button state...");
    // Check if any filter or search is active
    var eventType = $('select[name="eventType"]').val();
    var region = $('select[name="region"]').val();
    var search = $('input[name="search"]').val();

    if (eventType !== "all" || region !== "all" || search) {
      console.log("showing clear button");
      $(".category-clear").removeClass("hidden");
    } else {
      console.log("hiding clear button");
      $(".category-clear").addClass("hidden");
    }
  }

  function showLoadingMessage() {
    $(".loading-message").slideDown();
  }

  function hideLoadingMessage() {
    $(".loading-message").slideUp();
  }

  function updateFilters() {
    showLoadingMessage();

    var eventType = $('select[name="eventType"]').val();
    var region = $('select[name="region"]').val();

    // Make an AJAX request to your controller
    $.ajax({
      url: "/events/filterEvents",
      type: "GET",
      data: {
        eventType: eventType,
        region: region,
      },
      success: function (response) {
        console.log("AJAX Success! Response: " + response);

        // Parse the response string into a JavaScript object
        var data = JSON.parse(response);
        var content = data.content;
        var container = $(".filtered-events-list");

        if (container.length) {
          container.html(content);
        } else {
          console.error("no container found for filtered events");
        }

        updateDropdownOptions(data.categoryCounts, "eventType");
        updateDropdownOptions(data.regionCounts, "region");

        addMonthDividers();

        updateClearButtonState();
      },
      error: function (xhr, status, error) {
        // Handle errors
        console.error("An error occurred: " + error);
      },
      complete: function () {
        hideLoadingMessage();
      },
    });
  }

  function updateDropdownOptions(optionCounts, dropdownType) {
    // Find the correct dropdown based on the type
    var dropdown = $('select[name="' + dropdownType + '"]');

    // Update each option in the dropdown
    dropdown.find("option").each(function () {
      var optionValue = $(this).val();

      // Skip the 'All' option
      if (optionValue !== "all") {
        // Find the count for this option
        var count = optionCounts[optionValue] || 0;

        // Update the text and disabled status of the option
        var optionText = $(this).text().split(" (")[0]; // Strip existing count
        $(this).text(optionText + " (" + count + ")");
        $(this).prop("disabled", count === 0);
      }
    });
  }

  function addMonthDividers() {
    var container = $(".filtered-events-list .items-list");

    if (container.length) {
      // Get all the events
      var events = container.find(".item.snippet");

      // Create an object to store events by month and year
      var eventsByMonth = {};

      // Get the current year for comparison
      var currentYear = new Date().getFullYear();

      // Iterate through events and group them by month and year
      events.each(function () {
        var eventDate = new Date($(this).find(".date").text());
        var monthName = eventDate.toLocaleString("en-us", { month: "long" });
        var year = eventDate.getFullYear();
        var monthYearKey = monthName + (year !== currentYear ? " " + year : "");

        if (!eventsByMonth[monthYearKey]) {
          eventsByMonth[monthYearKey] = [];
        }

        eventsByMonth[monthYearKey].push(this);
      });

      // Clear the container
      container.html("");

      // Iterate through the grouped events and add them to the container with month and possibly year headers
      for (var monthYearKey in eventsByMonth) {
        container.append('<div class="item snippet month"><h3>' + monthYearKey + "</h3></div>");
        eventsByMonth[monthYearKey].forEach(function (event) {
          container.append(event);
        });
      }
    } else {
      console.error("No container found for filtered events");
    }
  }

  $(".register-button").on("click", function (e) {
    e.preventDefault();
    var url = $(this).data("url");
    window.location.href = url;
  });
});
